import { IntegrityMonitorDetailsPanelWebComponent } from './component/IntegrityMonitorDetailsPanelWebComponent';
import { WEB_COMPONENT_INTEGRITY_MONITOR_EVENTS_DETAILS_PANEL } from '../../../webcomponents.constants';

export { IntegrityMonitorDetailsPanelWebComponent };

window.customElements.define(
  WEB_COMPONENT_INTEGRITY_MONITOR_EVENTS_DETAILS_PANEL,
  IntegrityMonitorDetailsPanelWebComponent
);
